import { render, staticRenderFns } from "./PoiRegionSubjects.vue?vue&type=template&id=0e668b99"
import script from "./PoiRegionSubjects.js?vue&type=script&lang=js&external"
export * from "./PoiRegionSubjects.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports